import { injectPingdom } from './inject-pingdom'

export function load() {
  if (process.env.PINGDOM_URL) {
    injectPingdom(process.env.PINGDOM_URL)
  }
}
